export default "{\n    \"optionLabel\": \"Está Vencida\",\n    \"filterLabel\": \"Vencida\"\n}\n"